import { z } from 'zod/v4';

import { ApiIntegrationStatusRuntype } from './3rdPartyBackendTypes';

export type GreenchipsCurrencyDTO = z.infer<typeof GreenchipsCurrencyDTORuntype>;
export const GreenchipsCurrencyDTORuntype = z.enum(['EUR', 'USD']);

export interface GreenchipsCredentialsDTO extends z.infer<typeof GreenchipsCredentialsDTORuntype> {}
export const GreenchipsCredentialsDTORuntype = z.object({
    api_key: z.string(),
    currency: GreenchipsCurrencyDTORuntype,
});

export interface GreenchipsCredentialsInputDTO extends z.infer<typeof GreenchipsCredentialsInputDTORuntype> {}
export const GreenchipsCredentialsInputDTORuntype = z.object({
    api_key: z.string().optional(),
    currency: GreenchipsCurrencyDTORuntype.optional(),
});

export interface GreenchipsResponseBodyDTO extends z.infer<typeof GreenchipsResponseBodyDTORuntype> {}
export const GreenchipsResponseBodyDTORuntype = z.object({
    data: GreenchipsCredentialsDTORuntype.nullable(),
    status: ApiIntegrationStatusRuntype,
});
